import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import mmaImage from '../assets/img/mma.png';

const MMAPromoMobile = () => {
  return (
    <Card
      sx={{
        backgroundColor: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(212, 175, 55, 0.3)',
        borderRadius: '16px',
        overflow: 'hidden',
        mx: 'auto',
        maxWidth: '340px',
        width: '90%'
      }}
    >
      {/* Image Header */}
      <Box sx={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
        <Box
          component="img"
          src={mmaImage}
          alt="MMA Montauban"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            backgroundColor: '#D4AF37',
            color: '#000',
            px: 2,
            py: 0.75,
            borderRadius: '8px',
            fontSize: '0.875rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
          }}
        >
          -10%
        </Box>
      </Box>

      {/* Content */}
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="h5"
          component="a"
          href="https://agence.mma.fr/montauban-alsace-lorraine/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: '#D4AF37',
            fontWeight: 700,
            fontSize: '1.5rem',
            mb: 1,
            textAlign: 'center',
            textDecoration: 'none',
            display: 'block',
            transition: 'all 0.3s ease',
            '&:hover': {
              color: '#FFD369',
              transform: 'scale(1.02)'
            }
          }}
        >
          MMA Montauban
        </Typography>

        <Typography
          sx={{
            color: '#fff',
            fontSize: '0.95rem',
            mb: 2.5,
            textAlign: 'center',
            lineHeight: 1.5
          }}
        >
          Protection complète pour nos chauffeurs
        </Typography>

        <Box
          sx={{
            backgroundColor: 'rgba(212, 175, 55, 0.1)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '12px',
            p: 2,
            mb: 2.5
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontSize: '0.9rem',
              lineHeight: 1.6,
              mb: 2,
              textAlign: 'center'
            }}
          >
            <strong style={{ color: '#D4AF37' }}>10% de remise</strong> sur tous les contrats
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 1.5
            }}
          >
            {['RC PRO', 'Assurance véhicule', 'Mutuelle santé', 'Habitation', 'Retraite'].map((service, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(212, 175, 55, 0.15)',
                  color: '#D4AF37',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  py: 1,
                  px: 1.5,
                  borderRadius: '8px',
                  textAlign: 'center',
                  gridColumn: index === 4 ? 'span 2' : 'auto'
                }}
              >
                {service}
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
            pt: 1
          }}
        >
          <Typography
            sx={{
              color: '#999',
              fontSize: '0.8rem',
              fontWeight: 600
            }}
          >
            Agent Général MMA
          </Typography>
          <Typography
            sx={{
              color: '#666',
              fontSize: '0.75rem',
              textAlign: 'center'
            }}
          >
            📍 121 Bd Alsace Lorraine, Montauban
          </Typography>
          <Typography
            sx={{
              color: '#666',
              fontSize: '0.75rem'
            }}
          >
            📞 05 63 66 39 45
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MMAPromoMobile;
